/*
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Grid2 from "@mui/material/Unstable_Grid2";
import { ANALYSIS_COLLECTIONS } from "../../store/actions";
import MKBox from "../../components/MKBox";
import CollectionHub from "../../views/CollectionHub";

import MKTypography from "../../components/MKTypography";
import bgImage from "../../assets/images/backgrounds/bg-global012.png";
import analysisCollections from "../../store/constant/analysisCollections";

// eslint-disable-next-line import/no-cycle
import MainLayout from "../MainLayout";

const AnalysisHub = () => {
  const dispatch = useDispatch();
  const [ReturnCollections, setReturnCollections] = useState([]);

  const BreadcrumbsRoutes = [{ label: "Home", route: "/home" }, { label: "Analysis" }];

  useEffect(async () => {
    setReturnCollections(analysisCollections.collections);
    dispatch({ type: ANALYSIS_COLLECTIONS, value: analysisCollections.collections });
  }, []);

  return (
    <MainLayout breadcrumbsRoutes={BreadcrumbsRoutes}>
      <MKBox component="section" sx={{ height: "87vh", overflow: "auto" }}>
        <MKBox
          width={1}
          height="25vh"
          bgColor="white"
          sx={{
            alignItems: "center",
            backgroundImage: ({ palette: { dark, black }, functions: { linearGradient, rgba } }) =>
              `${linearGradient(rgba(dark.main, 0.2), rgba(black.main, 0.6))}, url(${bgImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "grid",
          }}
        >
          <MKBox
            mx={{ sm: 3, xl: 12, xxl: 24, xxxl: 36, xxxxl: 72 }}
            justifyContent={{ lg: "left", sm: "center" }}
          >
            <Grid2 container>
              <Grid2 xs={12} lg={7} xxl={6} xxxl={5}>
                <MKTypography variant="h2" color="white" textAlign="left">
                  Spatio-temporal, automate and visible.
                </MKTypography>
              </Grid2>
            </Grid2>
          </MKBox>
        </MKBox>
        <MKBox bgColor="white">
          <Grid2 container>
            <CollectionHub collections={ReturnCollections} linkPrefix="/analysis/" />
          </Grid2>
        </MKBox>
      </MKBox>
    </MainLayout>
  );
};

export default AnalysisHub;
